@if (status(); as setupStatus) {
  <mat-card class="setup-checklist-card">
    <mat-card-header>
      <mat-icon mat-card-avatar class="setup-checklist-avatar">task_alt</mat-icon>
      <mat-card-title>{{ title() }}</mat-card-title>
      <mat-card-subtitle>
        {{ setupStatus.completedSteps }}/{{ setupStatus.totalSteps }} completed
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="setup-checklist-progress">
        <mat-progress-bar
          mode="determinate"
          [value]="progressPercent()"
          aria-label="FI setup progress"
        ></mat-progress-bar>
        <span class="setup-checklist-progress-label">{{ progressPercent() }}%</span>
      </div>

      <ul class="setup-checklist-list">
        @for (step of steps(); track step.label) {
          <li class="setup-checklist-item">
            <mat-icon
              class="setup-checklist-item-icon"
              [class.setup-checklist-item-icon--done]="step.completed"
            >
              {{ step.completed ? 'check_circle' : 'radio_button_unchecked' }}
            </mat-icon>
            <span>{{ step.label }}</span>
          </li>
        }
      </ul>
    </mat-card-content>
    @if (nextAction(); as action) {
      <mat-card-actions>
        <button mat-flat-button [routerLink]="action.route">
          {{ action.label }}
        </button>
      </mat-card-actions>
    }
  </mat-card>
}
